// Swiper 4 uses max-width breakpoints. Match the category grid's 768/1200px
// boundaries while retaining swipe/navigation behavior on homepage rails.
const homepageProductSliderOptions = {
  breakpoints: {
    767: { slidesPerView: 2, spaceBetween: 16 },
    1199: { slidesPerView: 3, spaceBetween: 16 },
  },
  spaceBetween: 24,
}

export default homepageProductSliderOptions
